export default "<div class=\"ccc-discussion-list\">\n  <div id=\"discussionContainer\" class=\"discussion-container\"></div>\n</div>\n";